/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { FormProvider } from "@simplicitycms/simplicity-forms";
import { FeedbackHelpful } from "@simplicitycms/simplicity-forms";
import { useSimpliCityWebpage } from "@simplicitycms/simplicity-forms";

const FeedbackComponent = (props) => {

    const { component } = props;
    const { webpage, model } = useSimpliCityWebpage();

    return (
        <FormProvider>
            <FeedbackHelpful
                conponent={component}
                webpage={webpage}
                model={model}
            />
        </FormProvider>
    );
};

FeedbackComponent.displayName = "FeedbackComponent";
export { FeedbackComponent };
